"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Constants = {
  AuthenticationStatuses: {
    Authenticated: 'authenticated',
    Consumer: 'consumer',
    // only used in GCC
    Guest: 'guest',
    Persisted: 'persisted',
    Rep: 'rep' // only used in GCC

  },
  CookieNames: {
    InternalUser: 'internalUser'
  },
  DefaultTimeOut: 1000,
  EventModes: {
    Stash: 'stash'
  },
  EventNames: {
    CartAdd: 'cart add',
    CartAddLocation: 'cart add location'
  },
  FulfillmentMethods: {
    ShipToHome: 'sth'
  },
  PrimaryCategories: {
    ButtonSubmission: 'button submission',
    Overlay: 'overlay',
    Stash: 'stash'
  },
  PropertyPaths: {
    Category: 'category',
    EventInfo: 'eventInfo',
    EventMode: 'eventMode',
    Item: 'item',
    Stash: 'stash',
    UserProfileAuthenticationStatus: 'user.profile.authenticationStatus'
  },
  Sites: {
    Blinds: 3,
    TheHomeDepot: 11
  },
  Targets: {
    AddToCart: 'atc'
  }
};
var _default = Constants;
exports["default"] = _default;
//# sourceMappingURL=constants.js.map